export default __webpack_public_path__ + "static/media/Create schedule 1.47db7946.png";